__webpack_require__.p = "https://pricetemplates.epglobal.ae/";